export default {
  'Choose File': 'Scegli File',
  'Please paste a URL': 'Si prega di incollare un URL',
  'Loading': 'Caricamento in corso',
  'Analyzing': 'Analisi in corso',
  'Try a sample': 'Prova un esempio',
  'Sorry, error occurs when analyzing the URL.': "SCi spiace, si verifica un errore nel corso dell'analisi dell'URL.",
  'Upload a photo': 'Carica una foto',
  "Drag and drop files to the upload box.": 'Trascina e rilascia i file nella casella di caricamento.',
  'Please select the proper position with portrait.': 'Si prega di selezionare la posizione corretta con il ritratto.',
  'downloading': 'download',

}